import {
  Accordion,
  AccordionDetails,
  Divider,
  Grid,
  IconButton,
  Typography,
  useEventCallback,
} from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { BodyInterestedPeopleVM } from 'practice/view-models/practice-detail';
import Form from './form';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useParams } from 'react-router-dom';
import ResidenceOriginForm from './provenienza/form';
import { DateTime } from 'luxon';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import { ResidenceOrigin } from 'shell/view-models/personal-data';

interface AccordionPersonProps {
  person?: BodyInterestedPeopleVM;
  onClose: () => void;
  onChangePerson: (
    key: keyof BodyInterestedPeopleVM,
    value: BodyInterestedPeopleVM[keyof BodyInterestedPeopleVM],
    person?: BodyInterestedPeopleVM
  ) => void;
}

const AccordionPersonComponent = ({
  person,
  onClose,
  onChangePerson,
}: AccordionPersonProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const params = useParams();

  const onChangeResidencyOriginField = useEventCallback(
    (key: keyof ResidenceOrigin, value: ResidenceOrigin[keyof ResidenceOrigin]) => {
      onChangePerson(
        'residenceOrigin',
        {
          ...person?.residenceOrigin,
          [key]: value,
        },
        person
      );
    }
  );

  const onChangeResidencyOriginFields = useEventCallback((values: ResidenceOrigin) => {
    onChangePerson('residenceOrigin', values, person);
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-people-content"
        id="accordion-people-header"
        expandIcon={<ExpandMore />}
      >
        <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <Typography>
            {person?.surname || ''} {person?.name || ''}
          </Typography>
          <IconButton
            aria-label="chiudi"
            aria-haspopup="true"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onClose();
            }}
            style={{
              padding: '4px',
            }}
          >
            <HighlightOffIcon />
          </IconButton>
        </span>
      </AccordionSummary>
      <AccordionDetails>
        <Form disabled values={person} />
        <Grid container spacing={1} mt={2}>
          <Grid item xs={12}>
            <PmiTitleDivider>Provenienza</PmiTitleDivider>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <ResidenceOriginForm
              onChangeResidencyOriginField={onChangeResidencyOriginField}
              typeRegister={params.tipoRegistro}
              idAnpr={person?.idANPR}
              sipoSerialNumber={person?.sipoSerialNumber}
              fromDate={DateTime.now()}
              values={person?.residenceOrigin}
              onChangeResidencyOriginFields={onChangeResidencyOriginFields}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

AccordionPersonComponent.displayName = 'Practice Detail - Form - accordion person';

const AccordionPerson = memo(AccordionPersonComponent);

export default AccordionPerson;
